module.exports = require('lodash').clamp